import { HttpErrorResponse } from '@angular/common/http';

import { AuthService } from '@app/auth/services/auth.service';
import { AuthDOS } from '@app/auth/services/auth-dos.service';
import { getReleaseDate, getMenuLinks } from '@app/shared/utils/';
import { MessageService } from '@app/services/message.service';
import { ErrorMessage } from '@app/constants/messages.constants';
import { AppConfigService } from '@app/services/app-config.service';
import { Endpoint } from '@app/constants/endpoints.constants';

export function authInitializer(
  authService: AuthService,
  authDOS: AuthDOS,
  messageService: MessageService,
  appConfigService: AppConfigService
): () => void {
  return () =>
    Promise.all([authService.getConstants().toPromise(), appConfigService.loadConfig().toPromise()])
      .then(([appConstants]) => {
        authDOS.setMenuLinks(getMenuLinks(appConstants));
        authDOS.setReleaseDate(getReleaseDate(appConstants));
      })
      .catch((err: HttpErrorResponse) => {
        if (err.url.includes(Endpoint.Config)) {
          messageService.showErrorMessage(ErrorMessage.Config);
        } else {
          messageService.showErrorMessage(ErrorMessage.GetLinks);
        }

        console.error(err);
      });
}
